import React from "react";
import "./Features2.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

const Tick = () => (
  <svg
    width="42"
    height="34"
    viewBox="0 0 42 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.5141 0.850586L14.2435 22.1212L5.84031 13.718L0.0631104 19.5827L14.2435 33.7631L41.2913 6.71532L35.5141 0.850586Z"
      fill="#76BA1B"
    />
  </svg>
);

function Features2({ currentLocale }) {
  return (
    <section id="world-of-qr-codes">
      <p id="qr-codes" className="above-heading">
        <FormattedMessage id="home.features2.p" />
      </p>
      <h1>
        <FormattedMessage id="home.features2.h" />
      </h1>
      <div className="row">
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="0"
                class="animation1"
                src="animations-en/video1-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="1"
                class="animation1"
                src="animations-cs/video1-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
        <div className="text">
          <h3>
            <FormattedMessage id="home.features2.row1.h" />
          </h3>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row1.text1" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row1.text2" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row1.text3" />
          </div>
        </div>
      </div>
      <div className="row middle">
        <div className="text">
          <h3>
            <FormattedMessage id="home.features2.row2.h" />
          </h3>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row2.text1" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row2.text2" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row2.text3" />
          </div>
        </div>
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="2"
                class="animation2"
                src="animations-en/video2-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="3"
                class="animation2"
                src="animations-cs/video2-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
      </div>
      <div className="row">
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="4"
                class="animation3"
                src="animations-en/video3-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="5"
                class="animation3"
                src="animations-cs/video3-3/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
        <div className="text">
          <h3>
            <FormattedMessage id="home.features2.row3.h" />
          </h3>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row3.text1" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row3.text2" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.features2.row3.text3" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features2;
